import { normalizeUri } from '../../../utils/utils';
import { ItemKind } from '../../../constants/ItemKind';
import { MediaType } from '../../../constants/MediaType';
function toThumbnails(photo) {
  const thumbnail = photo.url_m || photo.url_s || photo.url_t;
  const big = photo.url_b || thumbnail;
  const original = photo.url_o || big;
  return {
    fileUrl: original,
    thumbnailUrl: thumbnail,
    previewUrl: big
  };
}
export const getMediaType = mediaType => mediaType === 'video' ? MediaType.Video : MediaType.Picture;
export function toItem(data) {
  const thumbnails = toThumbnails(data);
  return {
    id: data.id,
    name: data.title,
    kind: ItemKind.File,
    source: 'flickr',
    folderId: null,
    mediaType: getMediaType(data.media),
    fileUrl: normalizeUri(thumbnails.fileUrl),
    thumbnailUrl: normalizeUri(thumbnails.thumbnailUrl),
    previewUrl: normalizeUri(thumbnails.previewUrl),
    createdAt: null,
    tags: [],
    width: Number(data.width_o || data.width_m || data.width_s || data.width_t),
    height: Number(data.height_o || data.height_m || data.height_s || data.height_t)
  };
}